import {
    GET_CUSTOMER_CATEGORY_LIST_PROGRESS, GET_CUSTOMER_CATEGORY_LIST_SUCCESS, GET_CUSTOMER_CATEGORY_LIST_FAILURE,
    ADD_CUSTOMER_CATEGORY_PROGRESS, ADD_CUSTOMER_CATEGORY_SUCCESS, ADD_CUSTOMER_CATEGORY_FAILURE,
    EDIT_DELETE_CUSTOMER_CATEGORY_PROGRESS, EDIT_DELETE_CUSTOMER_CATEGORY_SUCCESS, EDIT_DELETE_CUSTOMER_CATEGORY_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    customerCategory: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const customer_category_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_CUSTOMER_CATEGORY_LIST_SUCCESS:
            return { ...state, customerCategory: action.customerCategory, loading: false };
        case GET_CUSTOMER_CATEGORY_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CUSTOMER_CATEGORY_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_CUSTOMER_CATEGORY_PROGRESS:
            return { ...state, loading: true };
        case ADD_CUSTOMER_CATEGORY_SUCCESS:
            return { ...state, customerCategory: [...state.customerCategory, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CUSTOMER_CATEGORY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_CUSTOMER_CATEGORY_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CUSTOMER_CATEGORY_SUCCESS:
            return {
                ...state,
                customerCategory: state.customerCategory.map((customerCategory) =>
                    customerCategory.id === action.payload.id ? action.payload : customerCategory
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CUSTOMER_CATEGORY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default customer_category_reducer;